export const searchButtonSx = {
  '&&': {
    backgroundColor: '#FFFFFF',
    color: '#263238',
    minWidth: '103.96px',
  },
  '&&:hover': {
    backgroundColor: '#D5D5D5',
    color: '#263238',
  },
  '&&:active': {
    backgroundColor: '#9E9E9E',
    color: '#263238',
  },
};
